export function onServiceWorkerUpdateReady() {
  window.location.reload(true)
}
